"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TokenListInput = require("./TokenListInput");
Object.keys(_TokenListInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenListInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TokenListInput[key];
    }
  });
});